export enum HeaderIconIcon {
  Business,
  CaretDown,
  Cart,
}

export interface HeaderIconProps {
  icon: HeaderIconIcon;
}
